import type { ReactElement } from "react";

import classNames from "classnames";
import { Stack } from "react-bootstrap";
import { Trans } from "react-i18next";
import { NavLink } from "react-router-dom";

import DesktopLanguageSwitcher from "@/components/languageSwitcher/DesktopLanguageSwitcher";
import Logo from "@/components/logo";
import LogoLink from "@/components/logoShortLink";
import LogoutButton from "@/components/logoutButton";
import Banner from "@/components/sidebar/components/Banner";
import UserSwitchInfo from "@/components/sidebar/components/UserSwitchInfo";
import { IS_ME_LINK } from "@/constants/app";
import { ROUTES } from "@/constants/routes";
import { isWebView } from "@/constants/webView";
import useLocalizedHref from "@/hooks/useLocalizedHref";
import { useAuthService } from "@/services/authService";

import styles from "./DesktopNavbar.module.scss";

interface IDesktopNavbarProps {
  menu: ReactElement;
}

function DesktopNavbar({ menu }: IDesktopNavbarProps) {
  const localizedHref = useLocalizedHref();
  const { isSwitchedUser, isPremium } = useAuthService();
  return (
    <nav
      className={classNames(
        "h-100 d-none d-lg-flex flex-column",
        styles.navbar,
        {
          "bg-danger-subtle": isSwitchedUser,
        }
      )}
    >
      <div
        className={classNames(
          "d-flex justify-content-center",
          styles.logoWrapper
        )}
      >
        {IS_ME_LINK ? <LogoLink /> : <Logo />}
      </div>
      <div
        className={classNames(
          "flex-grow-1 overflow-auto scrollbar-none pb-5",
          styles.menuWrapper
        )}
      >
        <UserSwitchInfo />

        <div>{menu}</div>
        {!IS_ME_LINK && !isPremium && (
          <div className={styles.bannerWrapper}>
            <Banner />
            <p className="text-center small mb-0 text-secondary">
              <Trans
                i18nKey="sidebarCrossPromo.upgradeToHide"
                components={[
                  <NavLink
                    to={localizedHref(ROUTES.SUBSCRIPTION)}
                    className="text-primary"
                  ></NavLink>,
                ]}
              />
            </p>
          </div>
        )}
      </div>
      {!isWebView && (
        <Stack
          direction="horizontal"
          gap={1}
          className={classNames("flex-wrap", styles.footerWrapper)}
        >
          <LogoutButton className="flex-grow-1" />
          <DesktopLanguageSwitcher className="flex-grow-1 d-flex flex-column" />
        </Stack>
      )}
    </nav>
  );
}

export default DesktopNavbar;
